export default "__VITE_ASSET__Cmfaz4mp__"